<app-config-filter-select (setFilter)="setFilter($event)"></app-config-filter-select>
<selfai-bi-config-filter-update
  (done)="emitUpdateFilter($event)"
  (goToSelectField)="showSelectFieldComp($event)"
></selfai-bi-config-filter-update>
